// cart-quantity-limit.js
// Enforces a max quantity of 5 per product across quick-add, bulk-add, and quick-order-list

(function () {
  const MAX_QTY = 5;
  const ERROR_CLASS = 'quantity-limit-error';

  const ERROR_STYLE = `
    .${ERROR_CLASS} {
      color: #FFF;
        font-size: 0.7em;
        margin-top: 6px;
        display: inline;
        position: absolute;
        right: 29px;
    }
  `;

  // Inject styles
  const style = document.createElement('style');
  style.textContent = ERROR_STYLE;
  document.head.appendChild(style);

  function showInlineError(inputEl, message) {
    // Remove any existing error for this input
    clearInlineError(inputEl);
    const err = document.createElement('span');
    err.className = ERROR_CLASS;
    err.textContent = message;
    inputEl.insertAdjacentElement('afterend', err);
  }

  function clearInlineError(inputEl) {
    const next = inputEl.nextElementSibling;
    if (next && next.classList.contains(ERROR_CLASS)) {
      next.remove();
    }
  }

  // Intercept fetch (Shopify uses fetch for cart AJAX in Dawn-based themes)
  const originalFetch = window.fetch;
  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : input?.url;

    if (url && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
      try {
        const body = init?.body;
        let data = {};

        if (typeof body === 'string') {
          try { data = JSON.parse(body); } catch { data = Object.fromEntries(new URLSearchParams(body)); }
        } else if (body instanceof FormData || body instanceof URLSearchParams) {
          data = Object.fromEntries(body);
        }

        // Fetch current cart to check existing quantities
        const cartRes = await originalFetch('/cart.js');
        const cart = await cartRes.json();

        const items = data.items || (data.id ? [{ id: data.id, quantity: parseInt(data.quantity) || 1 }] : []);

        for (const item of items) {
          const variantId = String(item.id);
          const existing = cart.items.find(i => String(i.variant_id) === variantId || String(i.id) === variantId);
          const existingQty = existing ? existing.quantity : 0;
          const requestedQty = parseInt(item.quantity) || 1;
          const totalQty = existingQty + requestedQty;

          if (totalQty > MAX_QTY) {
            // Find the quantity input for this variant and show inline error
            const inputEl = document.querySelector(
              `input[data-variant-id="${variantId}"], input[name="quantity"][data-id="${variantId}"], .quantity__input`
            );
            if (inputEl) {
              showInlineError(inputEl, `Max ${MAX_QTY} per product. You already have ${existingQty} in your cart.`);
            }

            // Return a mock failed response to prevent the add
            return new Response(
              JSON.stringify({ status: 422, message: `Maximum quantity of ${MAX_QTY} exceeded.`, description: {} }),
              { status: 422, headers: { 'Content-Type': 'application/json' } }
            );
          }
        }
      } catch (e) {
        console.warn('[QuantityLimit] Error during pre-check:', e);
      }
    }

    return originalFetch.apply(this, arguments);
  };

  // Also validate on quantity input change (for quick-order-list manual edits)
  document.addEventListener('change', function (e) {
    const input = e.target;
    if (input.classList.contains('otp-input-box') || !input.matches('input[type="number"], input.quantity__input, input[name="quantity"]')) {
      return;
    }
    clearInlineError(input);
    const val = parseInt(input.value);
    if (val > MAX_QTY) {
      input.value = MAX_QTY;
      // showInlineError(input, `Max ${MAX_QTY} per product allowed.`);
      showInlineError(input, `Max`);
    }
  });
})();
